'use client';
import React from 'react';

const __useId = React['useId'.toString()] || (()=>undefined);
function useReactId() {
    const id = __useId();
    return id ? `ds-${id.replace(/:/g, '')}` : '';
}

export { useReactId };
//# sourceMappingURL=useReactId.js.map
